export default "__VITE_ASSET__BtE8v_st__"